import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { ReactComponent as CircleInfoSVG } from "go-core/images/svg/circle-info.svg";
import { PartnerApi } from "../../../../services/Api/Partner/partnerTypes";
import { OrganizationApi } from "../../../../services/Api/types";

interface Props {
	organization: OrganizationApi;
	setShowPartnersProvisionsModal: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const OrganizationListPartnersInfo = ({ organization, setShowPartnersProvisionsModal }: Props) => {
	const { t } = useTranslation("admin");

	const drawPartnerInfo = (partner: PartnerApi, index: number) => {
		const provision = partner.provisions[0] || undefined;
		const remainingProvisions = partner.provisions.filter((_, provisionIndex) => provisionIndex > 0);
		const remainingProvisionsNumber = remainingProvisions.length;

		return (
			<>
				<small className="text-muted font-weight-bold">
					{partner.type && t(`enums.partner_types.${partner.type}`)}
					{provision &&
						` ${
							provision.type === "PERCENT"
								? `${provision.provision}%`
								: FormatMoney({
										amount: provision.provision || 0,
										currency: "PLN",
								  })
						} / ${provision.billing_period}`}
				</small>
				{remainingProvisionsNumber > 0 && (
					<div className="d-flex align-items-center flex-nowrap provisions-configuration">
						<small className="text-muted font-weight-bold me-1 text-nowrap">
							+{" "}
							{t("modules.organization.field.configurations.title", {
								count: remainingProvisionsNumber,
							})}
						</small>
						<OverlayTrigger
							placement="top"
							overlay={
								<Tooltip id={`tooltip-partner-${index}-provision-configurations`}>
									<div className="d-flex flex-column">
										{remainingProvisions.map((remainingProvision) => (
											<span key={remainingProvision.id}>
												{remainingProvision &&
													`${
														remainingProvision.type === "PERCENT"
															? `${remainingProvision.provision}%`
															: FormatMoney({
																	amount: remainingProvision.provision || 0,
																	currency: "PLN",
															  })
													} / ${remainingProvision.billing_period}`}
											</span>
										))}
									</div>
								</Tooltip>
							}
						>
							<CircleInfoSVG />
						</OverlayTrigger>
					</div>
				)}
			</>
		);
	};

	return organization.partners?.length > 0 ? (
		<div className="d-flex flex-column">
			{organization.partners.map((partner, index) => (
				<div className="d-flex flex-column" key={`partner-${index}`}>
					<Link to={`/partnership/${partner.partner_id}`} target={"_blank"}>
						{partner.name}
					</Link>
					<div className="d-flex flex-column">{drawPartnerInfo(partner, index)}</div>
				</div>
			))}
			{organization.partners.length > 0 && (
				<div className="mt-2">
					<Button
						variant="add"
						onClick={() => setShowPartnersProvisionsModal(organization.id)}
						style={{ width: "113px" }}
					>
						{t("common.action.show_more", { ns: "lib" })}
					</Button>
				</div>
			)}
		</div>
	) : (
		<></>
	);
};

export default OrganizationListPartnersInfo;
